import React from 'react';
import ListEditItem from '../../../shared/ListEditItem';
import { renderText } from '../../../shared/DrawerLayout/renderText';
import styles from '../UserInfo.styles';
import ListItem from '../../../shared/ListItem';
import OrgaPdfItem from '../../../TripDrawer/OrgaPdfItem';

interface UserIdentityInfoProps {
  selectedUser: any;
  intl: any;
  onEditOrg: () => void;
}

const UserOrgInfo: React.FC<UserIdentityInfoProps> = ({
  selectedUser,
  intl,
  onEditOrg,
}) => {
  const address = selectedUser?.address?.streetName
    ? `${selectedUser.address.streetName}, ${
        selectedUser.address.streetNumber
      }, ${selectedUser.address.postalCode}, ${selectedUser.address.city}, ${
        selectedUser.address.country || 'DE'
      }`
    : null;
  const addressMismatch = !!selectedUser?.addressMismatch;
  return (
    <>
      <div className="user-section-title" style={{ marginTop: 10 }}>
        {intl.formatMessage({ id: `fleetadmin.users.info.org` })}
      </div>
      <ListEditItem
        label={intl.formatMessage({ id: `fleetadmin.users.info.companyname` })}
        leftItem={renderText(selectedUser?.companyName, false)}
        verified={selectedUser?.companyVerified}
        onClickEdit={onEditOrg}
      />
      <ListEditItem
        label={intl.formatMessage({ id: `fleetadmin.users.info.legaltype` })}
        leftItem={renderText(selectedUser?.legalType, false)}
        verified={selectedUser?.companyVerified}
        onClickEdit={onEditOrg}
      />
      {selectedUser?.legalType === 'Sonstige' && (
        <ListEditItem
          label={intl.formatMessage({
            id: `fleetadmin.users.info.otherlegaltype`,
          })}
          leftItem={renderText(selectedUser?.otherLegalType, true)}
          verified={selectedUser?.companyVerified}
          onClickEdit={onEditOrg}
        />
      )}
      <ListEditItem
        label={intl.formatMessage({
          id: `fleetadmin.users.info.registerNr`,
        })}
        leftItem={renderText(selectedUser?.registerNr, false)}
        verified={selectedUser?.companyVerified}
        onClickEdit={onEditOrg}
      />
      <ListEditItem
        label={intl.formatMessage({
          id: `fleetadmin.users.info.registerLocation`,
        })}
        leftItem={renderText(selectedUser?.registerLocation, false)}
        verified={selectedUser?.companyVerified}
        onClickEdit={onEditOrg}
      />
      <ListEditItem
        label={intl.formatMessage({ id: `fleetadmin.users.info.address` })}
        leftItem={renderText(address, false)}
        verified={selectedUser?.addressVerified}
        warning={addressMismatch}
        onClickEdit={onEditOrg}
      />
      <ListItem
        label={intl.formatMessage({
          id: 'fleetadmin.users.org.registration.pdf',
        })}
        value={<OrgaPdfItem uri={selectedUser?.legalEntityPdfUrl || ''} />}
      />
      <style jsx>{styles}</style>
    </>
  );
};

export default UserOrgInfo;
